import React, { useContext } from "react"
import { Route, Redirect } from "react-router-dom";
import { QuoteContextStore } from "../../../context/QuoteContext/QuoteContext";
import { SessionContextStore } from "../../../context/SessionContext/SessionContext";


export const PilotsProtectedRoute = ({children, quoteId, ...rest}) => {
    const { pilots, quoteLoaded } = useContext(QuoteContextStore);

    return (
        <Route
          {...rest}
          render={(props) => {
            if (!quoteLoaded) {
              return <div />
            } else if (pilots && Object.keys(pilots).length > 0) {
              return children;
            } else {
              return <Redirect to={{
                pathname: "/insurance/pilots/" + quoteId,
                state: { from: props.location}
              }} />
            }
          }}
        />
      );
}

export default PilotsProtectedRoute;